<template>
  <div class="container">
    <div class="left">
      <img src="../assets/images/404.png" />
    </div>
    <div class="right">
      <div class="fontS40">404</div>
      <div class="prompt">抱歉，你访问的页面不存在</div>
      <el-button type="danger" @click="goIndex">返回首页</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "error404",
    data() {
      return {}
    },
    methods: {
      //回到首页
      goIndex(){
        this.$router.push("/");
      }
    }
  }
  
</script>

<style scoped>
  .container {
    display: flex;
    margin-top: 200px;
    justify-content: center;
    align-items: center;
  }
  .left{
    margin-right: 50px;
  }
  .fontS40{
    font-size: 40px;
  }
  .prompt {
    font-size: 20px;
    color: #878686;
    margin: 15px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/error404.vue